import { Button, CircularProgress, Dialog, DialogContent, Table, TableCell, TableContainer, TableRow, TableHead, TableBody } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import PageTitle from 'components/PageTitle/PageTitle';
import featuresSAService from 'services/superadmin/featuresSAService';
import { FeatureForm } from './components/FeatureForm';
import { useState } from 'react';
import { toast } from 'react-toastify';

export const Features = () => {
    const { data, isLoading, refetch } = useQuery({
        queryKey: ['features'],
        queryFn: async () => {
            const { data } = await featuresSAService.getAll();
            return data;
        },
        refetchOnWindowFocus: false,
    });


    const [isOpenFeatureForm, setIsOpenFeatureForm] = useState(false);
    const [feature, setFeature] = useState<any>(null);

    const handleEditFeature = async (v: any) => {
        setFeature(v);
        setIsOpenFeatureForm(true);
    }

    const onSubmit = async (data: any) => {
        try {
            if (feature?.id) {
                await featuresSAService.update(feature.id, data);
                toast.success('Функционал успешно обновлен!');
            } else {
                await featuresSAService.create(data);
                toast.success('Функционал успешно создан!');
            }
            refetch();

        } catch (error) {
            console.log(error);
            toast.error('Ошибка при сохранении функционала!');
        } finally {
            setIsOpenFeatureForm(false);
            setFeature(null);
        }
    }


    const onDelete = async (u: any) => {
        try {
            await featuresSAService.delete(u.id);
            toast.success('Функционал успешно удален!');
            refetch();
        } catch (error) {
            console.log(error);
            toast.error('Ошибка при удалении функционала!');
        }
    };

    if (isLoading) {
        return <div className="text-center"><CircularProgress></CircularProgress></div>
    }

    return (
        <div>
            <div className="flex justify-between items-center mb-6">
                <PageTitle>Список функционала тарифа</PageTitle>
                <Button variant="contained" color="primary" onClick={() => setIsOpenFeatureForm(true)}>Добавить функционал</Button>
            </div>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>Системное название</TableCell>
                            <TableCell>Название</TableCell>
                            <TableCell>Категория</TableCell>
                            <TableCell>Тип</TableCell>
                            <TableCell>Единица измерения</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.map((item: any) => (
                            <TableRow key={item.id}>
                                <TableCell>{item.id}</TableCell>
                                <TableCell>{item.code}</TableCell>
                                <TableCell>{item.name}</TableCell>
                                <TableCell>{item.category}</TableCell>
                                <TableCell>{item.type}</TableCell>
                                <TableCell>{item.unit}</TableCell>
                                <TableCell>
                                    <Button variant="outlined" color="info" onClick={() => handleEditFeature(item)}>Редактировать</Button>
                                </TableCell>
                                <TableCell>
                                    <Button variant="outlined" color="error" onClick={() => onDelete(item)}>Удалить</Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {/* FeatureForm */}
            <Dialog fullWidth maxWidth="md" open={isOpenFeatureForm} onClose={() => {
                setIsOpenFeatureForm(false);
                setFeature(null);
            }}>
                <DialogContent>
                    <FeatureForm feature={feature} onSubmit={onSubmit} />
                </DialogContent>
            </Dialog>
        </div>
    );
}
